/** Shared pagination markup with icomoon dots. */
export const dotButtonMarkup = (extraClass = '', label = 'Go to slide') =>
  `<button type="button" class="with-svg ${extraClass}" aria-label="${label}">
    <i class="icon icon-slider-dot" aria-hidden="true"></i>
    <i class="icon icon-slider-dot-active" aria-hidden="true"></i>
  </button>`
